import { motion } from 'framer-motion';
import styled from 'styled-components';

import { color, mq, space } from '@/stylesheets';

export const ListWrapper = styled.div`
  width: 100%;
  padding: 0 ${space('s')};
  margin: 0 auto;
  position: relative;
  margin-bottom: ${space('xxl')};

  ${mq('m')} {
    padding: 0 ${space('m')};
  }

  ol {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }
`;

export const ListHeaderDesktop = styled.div`
  position: sticky;
  width: 100%;
  height: 50px;
  border-bottom: 2px solid ${color('primary', 10)};
  padding: ${space('s')};
  background: ${color('neutral', 10)};
  top: ${space('xl')};
  z-index: 9;
  display: none;

  ${mq('m')} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &:before,
  &:after {
    position: absolute;
    width: 25px;
    height: calc(100% + 4px);
    background: ${color('neutral', 10)};
    content: '';
    display: none;

    ${mq('m')} {
      display: block;
    }
  }

  &:before {
    left: -25px;
  }

  &:after {
    right: -25px;
  }

  button {
    width: calc(18.5% - ${space('xs')});
    text-align: left;
    text-transform: uppercase;
    margin-right: ${space('xs')};

    &:nth-of-type(4) {
      width: calc(22% - ${space('xs')});
    }

    &:first-of-type {
      width: auto;
      flex-grow: 2;
    }
  }
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${space('s')};
  padding: ${space('s')};
  text-align: left;
  color: ${color('primary')};

  &:hover,
  &:focus {
    p {
      text-decoration: underline;
      text-decoration-thickness: 2px;
      text-underline-offset: 3px;
    }
  }

  svg {
    margin-right: ${space('xxs')};
  }
`;

export const NoResultsWrapper = styled(ListWrapper)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > * + * {
    margin-top: ${space('m')};
  }
`;

export const ListLoader = styled(motion.div as any)`
  position: fixed;
  bottom: ${space('s')};
  right: ${space('s')};
  background: ${color('neutral', 10)};
  box-shadow: 0 0 5px 2px ${color('primary')};
  padding: ${space('xs')};

  ${mq('m')} {
    padding: ${space('s')};
  }
`;
